<ng-container *ngIf="_purchaseable === 'loading'">
  <button class="btn-sm btn btn-dark py-2" disabled>Loading...</button>
</ng-container>
<ng-container *ngIf="_purchaseable !== 'loading'">
  <ng-container *ngIf="_purchaseable === 'outofstock'">
    <button disabled class="btn-sm btn btn-dark py-2">
      {{ _text }}
    </button>
  </ng-container>
  <ng-container *ngIf="_purchaseable === 'add'">
    <button (click)="addToCart()" class="btn-sm btn btn-dark py-2">
      {{ _text }}
    </button>
  </ng-container>
</ng-container>
